module.exports = __webpack_public_path__ + "img/daily-sales.d5bfba09.svg";